import { store } from '@/store';

const isMember = (cardId, currentFilters, members) => {
  const membersInclude = members ?? currentFilters?.include?.members;
  const membersExclude = members ?? currentFilters?.exclude?.members;
  if (membersInclude?.length) {
    const card = store.getters.getCards[cardId];
    if (
      card.members?.some((m) => membersInclude.includes(m.user_id)) ||
      currentFilters?.has_members === false
    ) {
      return cardId;
    }

    return false;
  }
  if (membersExclude?.length) {
    const card = store.getters.getCards[cardId];
    if (card.members?.some((m) => membersExclude.includes(m.user_id))) {
      return false;
    }
    return cardId;
  }
  return cardId;
};

const isTag = (cardId, currentFilters, tags) => {
  const includeTags = tags ?? currentFilters?.include?.tags;
  const excludeTags = tags ?? currentFilters?.exclude?.tags;
  if (includeTags?.length) {
    const card = store.getters.getCards[cardId];
    if (card.tags?.some((t) => includeTags.includes(t.id))) {
      return cardId;
    }
    return false;
  }
  if (excludeTags?.length) {
    const card = store.getters.getCards[cardId];
    if (card.tags?.some((t) => excludeTags.includes(t.id))) {
      return false;
    }
    return cardId;
  }
  return cardId;
};

export { isMember, isTag };
